module.exports = __webpack_public_path__ + "img/note.57384017.svg";